import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  model,
  output,
  viewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import { TestPlanRun } from '../../../../models/test-plan.model';
import { FIELD_LENGTHS } from '../../../../shared/field-lengths';

@Component({
  selector: 'app-selection-change-dialog',
  standalone: true,
  imports: [ConfirmDialogComponent, TranslateModule],
  templateUrl: './selection-change-dialog.component.html',
  styleUrl: './selection-change-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionChangeDialogComponent {
  readonly added = input.required<string[]>();
  readonly removed = input.required<string[]>();
  /** `null` heißt unbekannt: Die Läufe laden noch (`loading`) oder das Laden ist gescheitert. */
  readonly runs = input.required<TestPlanRun[] | null>();
  readonly loading = input(false);
  readonly reopensPlan = input(false);
  readonly reason = model('');

  readonly confirmed = output<void>();
  readonly cancelled = output<void>();

  readonly maxReason = FIELD_LENGTHS.TEST_PLAN_CHANGE_REASON_MAX;

  readonly loadFailed = computed(() => !this.loading() && this.runs() === null);
  readonly countedRuns = computed(() => this.runs()?.filter((run) => run.counted).length ?? 0);
  readonly runningRun = computed(() => this.runs()?.find((run) => run.running) ?? null);
  readonly danger = computed(() => this.removed().length > 0 && this.countedRuns() > 0);

  private readonly reasonField = viewChild<ElementRef<HTMLTextAreaElement>>('reasonField');

  constructor() {
    // Beim Laden sind die Knöpfe gesperrt; ohne eigenen Startfokus bliebe der Fokus hinter dem Dialog.
    afterNextRender(() => this.reasonField()?.nativeElement.focus());
  }
}
